import React from "react";
import Markdown from "react-markdown";
import { ToolActivity } from "./ToolActivity";
import { ActionConfirmation } from "./ActionConfirmation";
import type { PendingMessage, ToolCall, ToolResultInfo, ConfirmationRequest } from "./types";

interface ChatMessageBubbleProps {
  message: PendingMessage;
  toolCalls?: ToolCall[];
  toolResults?: ToolResultInfo[];
  confirmation?: ConfirmationRequest | null;
  onConfirm?: () => void;
  onReject?: () => void;
  isLastAssistant?: boolean;
}

export const ChatMessageBubble: React.FC<ChatMessageBubbleProps> = ({
  message,
  toolCalls = [],
  toolResults = [],
  confirmation,
  onConfirm,
  onReject,
  isLastAssistant = false,
}) => {
  const isAssistant = message.role === "assistant";

  return (
    <div
      className={`chat-bubble${message.streaming ? " chat-streaming-cursor" : ""}`}
      data-role={message.role}
    >
      {isAssistant && isLastAssistant && toolCalls.length > 0 && (
        <ToolActivity toolCalls={toolCalls} toolResults={toolResults} />
      )}
      {message.content ? (
        isAssistant ? (
          <Markdown>{message.content}</Markdown>
        ) : (
          message.content
        )
      ) : (
        message.streaming ? "" : "..."
      )}
      {isAssistant && isLastAssistant && confirmation && onConfirm && onReject && (
        <ActionConfirmation
          confirmation={confirmation}
          onConfirm={onConfirm}
          onReject={onReject}
        />
      )}
    </div>
  );
};
